import {Component, Input} from '@angular/core';

import {HelpCopyAdComponent} from "./components/help-copy-ad/help-copy-ad.component";
import {HelpCreateAdComponent} from "./components/help-create-ad/help-create-ad.component";
import {HelpEditAdComponent} from "./components/help-edit-ad/help-edit-ad.component";
import {HelpRefreshAdComponent} from "./components/help-refresh-ad/help-refresh-ad.component";
import {HelpPauseAdComponent} from "./components/help-pause-ad/help-pause-ad.component";
import {HelpDeleteAdComponent} from "./components/help-delete-ad/help-delete-ad.component";

@Component({
  selector: 'nz-ad-management',
  standalone: true,
  imports: [
    HelpCopyAdComponent,
    HelpCreateAdComponent,
    HelpEditAdComponent,
    HelpRefreshAdComponent,
    HelpPauseAdComponent,
    HelpDeleteAdComponent
  ],
  templateUrl: './ad-management.component.html',
  styleUrl: './ad-management.component.scss'
})
export class AdManagementComponent {
  @Input() subsectionId?: number;
}
